import { render, staticRenderFns } from "./DeleteAlbumModal.vue?vue&type=template&id=5d977324"
import script from "./DeleteAlbumModal.vue?vue&type=script&lang=js"
export * from "./DeleteAlbumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports